import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useProjects } from '../../hooks/useProjects';
const cardColors = ['bg-gray-200', 'bg-gray-300', 'bg-gray-400', 'bg-slate-200'];
export function WorkPreviewSection() {
  const {
    projects: sheetProjects,
    loading,
    error
  } = useProjects();
  // Show up to 4 most recent projects (last added = most recent)
  const preview = [...sheetProjects].reverse().slice(0, 4);
  // Don't render the section at all if no projects and not loading
  if (!loading && sheetProjects.length === 0) return null;
  return <Section id="work" background="white" data-id="element-357">
      <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-358">
        <div data-id="element-359">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold font-heading text-[#0C0C0C] mb-4" data-id="element-360">
            Selected Work
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-gray-600 max-w-xl" data-id="element-361">
            A glimpse into the digital products, platforms, and experiences
            we've crafted.
          </motion.p>
        </div>
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-6 md:mt-0" data-id="element-362">
          <Link to="/work" data-id="element-363">
            <Button variant="outline" rightIcon={<ArrowRight size={16} data-id="element-365" />} data-id="element-364">
              View All Projects
            </Button>
          </Link>
        </motion.div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-366">
        {loading ? Array.from({
        length: 4
      }).map((_, i) => <div key={i} className="animate-pulse" data-id="element-367">
                <div className="aspect-[4/3] rounded-xl bg-gray-200 mb-4" data-id="element-368" />
                <div className="h-5 bg-gray-200 rounded w-3/4 mb-2" data-id="element-369" />
                <div className="h-4 bg-gray-100 rounded w-1/2" data-id="element-370" />
              </div>) : preview.map((project, index) => <motion.a key={project.id} href={project.live_url || '/work'} target={project.live_url ? '_blank' : '_self'} rel="noopener noreferrer" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="group cursor-pointer block" data-id="element-371">
                <div className={`aspect-[4/3] rounded-xl overflow-hidden mb-4 ${project.cover_image ? 'bg-gray-100' : cardColors[index % cardColors.length]} relative`} data-id="element-372">
                  {project.cover_image ? <img src={project.cover_image} alt={project.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-373" /> : <>
                      <div className="absolute inset-0 bg-[#0C0C0C]/0 group-hover:bg-[#0C0C0C]/5 transition-colors duration-300" data-id="element-374" />
                      <div className="w-full h-full flex items-center justify-center text-gray-400" data-id="element-375">
                        <svg className="w-12 h-12 opacity-20" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-376">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-377" />
                        </svg>
                      </div>
                    </>}
                </div>
                <h3 className="text-xl font-bold font-heading text-[#0C0C0C] group-hover:text-[#00316B] transition-colors" data-id="element-378">
                  {project.title}
                </h3>
                <p className="text-sm text-gray-500 mt-1" data-id="element-379">{project.category}</p>
              </motion.a>)}
      </div>
    </Section>;
}